module.exports = __webpack_public_path__ + "img/SIPE.e9331833.jpg";